import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { AdminService } from '../services/admin.service';
import { MatTableDataSource } from "@angular/material/table";
import { Student } from 'backend/interfaces/student.interface';
import { Observable } from 'rxjs';
import { faBirthdayCake, faCalendar, faChevronLeft, faChevronRight, faEye, faPhotoVideo, faPlus, faSearch, faUserAlt } from '@fortawesome/free-solid-svg-icons';
import { Router } from '@angular/router';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { SidenavActions, SideNavService } from '../services/side-nav.service';
import { ParentService } from '../services/parent.service';
import { CalendarEvent, CalendarEventAction, CalendarEventTimesChangedEvent, CalendarView } from 'angular-calendar';
import { AppointmentService } from 'src/app/services/appointment.service';
import { DataService } from 'src/app/services/data.service';
import { MatDialog } from '@angular/material/dialog';
import { FormBuilder, UntypedFormGroup } from '@angular/forms';
import { GroupService } from '../services/group.service';
import { BusinessService } from '../services/business.service';
import { Business } from 'backend/interfaces/business.interface';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})

export class DashboardComponent implements OnInit, AfterViewInit {
  students$: Observable<Student[]>;
  faHome = faEye;
  faSearch = faSearch;
  displayLimit = 10;
  page = 0;
  faPhoto = faPhotoVideo;
  faBirthday = faBirthdayCake;
  faCalendar = faCalendar;
  faFaceFinder = faUserAlt;
  sideNavActions = SidenavActions;
  albumList = [];
  businessesCount = '0';
  adCount = '0';
  newBookingForm: UntypedFormGroup;
  passedTime = new Date().getHours() - 1;
  @ViewChild('studentsPaginator') studentsPaginator: MatPaginator;
  constructor(public businessService: BusinessService, private router: Router, private sidenav: SideNavService, private parentService: ParentService, private appointmentService: AppointmentService, private dataService: DataService, public dialog: MatDialog, private fb: FormBuilder, private groupService: GroupService, private adminService: AdminService) { 
  }
  studentBirthdays = [];
  parentBirthdays = [];
  view: CalendarView = CalendarView.Day;
  displayedColumns: string[] = [
    'Client',
    'Occupation',
    'Mobile',
    'Email',
    'Actions'
  ];
  parentCount;
  faChevronRight = faChevronRight;
  faChevronLeft = faChevronLeft;
  students: Business[] = [];
  events: CalendarEvent[] = [];
  viewDate = new Date();
  dataSource: MatTableDataSource<Business>;
  pageEvent: PageEvent;
  studentCount;
  loading = false;
  faPlus = faPlus;
  categoryCount = '0';
  userCount = '0';
  chartData = 10;
  barChartData = []
  async ngOnInit(): Promise<void>{
    this.loading = true;
    await this.adminService.getUserCount();
    this.groupService.groupCount$.subscribe(res => {
      if(res){
      this.categoryCount = res.toString();
      }
    }
    );
    this.adminService.userCount$.subscribe(res => {
      if(res){
      this.userCount = res.toString();
      this.barChartData.push({ name: "Users", value: this.userCount, color: "#b18731" })
      }
    }
    );
    this.businessService.businessCount$.subscribe(res => {
      if(res){
      this.businessesCount = res.toString();
      this.barChartData.push({ name: "Businesses", value: this.businessesCount, color: "#533a84" })
      }
    }
    );
    this.adminService.adCount$.subscribe(res => {
      if(res){
      this.adCount = res.toString();
      this.barChartData.push({ name: "Ads", value: this.adCount, color: "#63adfeb3" })
      }
    }
    );
    this.loading = false;
  }

  ngAfterViewInit(): void {
  }

  async getStudents(e?: PageEvent): Promise<void> {
    this.loading = true;
    if(e){
      this.displayLimit = e.pageSize;
      this.page = e.pageIndex;
    }
    await this.businessService.getBusinesses(this.displayLimit, this.page);
    this.businessService.businesses$.subscribe(res => {
      this.students = res;
      this.dataSource = new MatTableDataSource(this.students);
    })


    this.dataSource = new MatTableDataSource(this.students);
    this.loading = false;
  }

  openBusiness(id: string){
    this.router.navigate(['admin', 'business', id]);
  }

  createBusiness(): void {
    this.businessService.activatedBusiness.next(null);
    this.openSideNav(SidenavActions.NewBusiness);
  }


  findBusiness(): void {
    this.openSideNav(SidenavActions.SearchBusiness);
  }

  createCategory(): void {
    this.openSideNav(SidenavActions.NewGroup);
  }

  findCategory(): void {
    this.openSideNav(SidenavActions.SearchGroup);
  }

  openSideNav(action: SidenavActions): void {
    this.sidenav.open(action);
  }

  goTo(route: string): void {
    this.router.navigate(['admin', route]);
  }
}
